import { getThemeType } from './env'
import { isHLApp } from './index'

// 设置主题
export const setTheme = () => {
    // TODO: 初始化主题 white - 白皮肤 black - 黑皮肤
    const theme = getThemeType()
    console.log('---theme---:', theme)
    document.documentElement.setAttribute('data-theme', theme)
    // TODO: 清除强制颜色
    if (theme === 'black') {
        if (!document.documentElement.classList.contains('dark_background')) {
            document.documentElement.classList.add('dark_background')
            document.body.classList.add('dark_background')
        }
    } else {
        if (!document.documentElement.classList.contains('white_background')) {
            document.documentElement.classList.add('white_background')
            document.body.classList.add('white_background')
        }
    }
}

// 移除主题
export const removeTheme = () => {
    document.documentElement.setAttribute('data-theme', 'white')
    // TODO: 非首页设置白色背景色
    document.documentElement.classList.remove('dark_background')
    document.body.classList.remove('dark_background')

    if (!document.documentElement.classList.contains('white_background')) {
        document.documentElement.classList.add('white_background')
        document.body.classList.add('white_background')
    }
}

/**
 * 主题工具类 - 用于在组件中监听主题变化
 */
export class ThemeWatcher {
    constructor() {
        this.mediaQueryList = null
        this.handleThemeChange = null
    }

    /**
     * 获取当前是否为浅色主题
     * @returns {boolean}
     */
    static isLight() {
        if (isHLApp()) {
            return getThemeType() === 'white'
        }
        // return true
        return window.matchMedia('(prefers-color-scheme: light)').matches
    }

    /**
     * 开始监听主题变化（仅在H5环境下有效）
     * @param {Function} callback - 主题变化回调函数，参数为 isLight (boolean)
     */
    watch(callback) {
        if (isHLApp()) {
            return
        }

        this.mediaQueryList = window.matchMedia('(prefers-color-scheme: light)')
        this.handleThemeChange = () => {
            callback()
        }
        if (this.mediaQueryList.addEventListener) {
            this.mediaQueryList.addEventListener('change', this.handleThemeChange)
        } else if (this.mediaQueryList.addListener) {
            this.mediaQueryList.addListener(this.handleThemeChange)
        }
    }

    /**
     * 停止监听主题变化
     */
    unwatch() {
        if (this.mediaQueryList && this.handleThemeChange) {
            if (this.mediaQueryList.addEventListener) {
                this.mediaQueryList.removeEventListener('change', this.handleThemeChange)
            } else if (this.mediaQueryList.removeListener) {
                this.mediaQueryList.removeListener(this.handleThemeChange)
            }
            this.mediaQueryList = null
            this.handleThemeChange = null
        }
    }
}
